import { svg } from 'lit';

const FlatChevron = (color: string) => (
  svg`
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M4.89803 1.85226L4.10254 2.64776L7.45479 6.00001L4.10254 9.35226L4.89803 10.1478L9.04578 6.00001L4.89803 1.85226Z"
        fill=${color}
        stroke=${color}
        fill-opacity="0.9"
      />
    </svg>
  `
);

export default FlatChevron;
